import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "flex flex-col w-full h-full text-white"
};
var _hoisted_2 = {
  "class": "flex items-center justify-center flex-1"
};
var _hoisted_3 = {
  key: 0,
  "class": "w-full max-w-[986px] px-8 mt-16 mb-8"
};
var _hoisted_4 = {
  "class": "max-w-[620px] mx-auto"
};
var _hoisted_5 = {
  "class": "grid grid-cols-1 md:grid-cols-2 gap-6 mb-2xl m-2xl"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  "class": "VerificationRelationshipIcon flex mb-6 justify-center rounded-full"
};
var _hoisted_8 = {
  "class": "max-w-[260px] text-md leading-relaxed font-semibold"
};
var _hoisted_9 = {
  "class": "flex justify-center"
};
var _hoisted_10 = {
  key: 1,
  "class": "w-full max-w-[986px]"
};
var _hoisted_11 = {
  "class": "flex flex-col lg:flex-row gap-6"
};
var _hoisted_12 = {
  "class": "flex flex-col flex-1"
};
var _hoisted_13 = {
  "class": "flex flex-col flex-1 Section"
};
var _hoisted_14 = {
  "class": "min-h-[82px] p-6 text-lg font-semibold flex items-center Section__top"
};
var _hoisted_15 = {
  "class": "p-6 flex flex-col flex-1"
};
var _hoisted_16 = {
  "class": "mb-6 leading-relaxed"
};
var _hoisted_17 = {
  "class": "flex flex-wrap gap-3 mb-6"
};
var _hoisted_18 = {
  "class": "list-disc pl-6"
};
var _hoisted_19 = {
  "class": "my-8"
};
var _hoisted_20 = {
  "class": "mb-8"
};
var _hoisted_21 = {
  "class": "flex flex-col flex-1"
};
var _hoisted_22 = {
  "class": "flex flex-col flex-1 Section"
};
var _hoisted_23 = {
  "class": "min-h-[82px] p-6 text-lg font-semibold flex items-center Section__top"
};
var _hoisted_24 = {
  "class": "p-6 flex flex-col flex-1"
};
var _hoisted_25 = {
  "class": "mb-6 leading-relaxed"
};
var _hoisted_26 = {
  "class": "flex flex-wrap gap-3 mb-6"
};
var _hoisted_27 = {
  "class": "list-disc pl-6"
};
var _hoisted_28 = {
  "class": "mt-auto"
};
var _hoisted_29 = {
  "class": "mb-8"
};
var _hoisted_30 = {
  key: 0
};
var _hoisted_31 = {
  key: 1
};
var _hoisted_32 = {
  "class": "mt-1"
};
var _hoisted_33 = {
  key: 0
};
var _hoisted_34 = {
  key: 1
};
var _hoisted_35 = {
  key: 2
};
import Footer from "@/layouts/main-layout/Footer.vue";
import Header from "@/layouts/main-layout/Header.vue";
import PBKYCFlow from "@/pages/auth/modals/PBKYCFlow.vue";
import verificationCorporateSuite from "@/validators/verificationCorporateSuite";
import verificationIndividualSuite from "@/validators/verificationIndividualSuite";
import { computed } from 'vue';
import { useStore } from 'vuex';
import { USER_LEGAL_ROLES, USER_STATUS } from "@/constants";

import { reactive, ref } from 'vue';
export default {
  __name: 'Verification',
  setup: function setup(__props) {
    var store = useStore();
    var user = computed(function () {
      return store.state.auth.user;
    });
    // const user = computed(() => {
    //   return Object.assign({}, store.state.auth.user, {
    //     detelioLink: null,
    //     status: 1
    //   });
    // });
    var status = computed(function () {
      return user.value.status;
    });
    var isDisabled = computed(function () {
      return status.value === USER_STATUS.DISABLED;
    });
    var isPendingEmail = computed(function () {
      return status.value === USER_STATUS.PENDING_EMAIL_CONFIRMATION;
    });
    var isPendingKyc = computed(function () {
      return status.value === USER_STATUS.PENDING_KYC;
    });
    var isKycRejected = computed(function () {
      return status.value === USER_STATUS.KYC_REJECTED;
    });
    var verificationInProgress = computed(function () {
      return localStorage.getItem("verification_in_progress") === "true";
    });
    var shouldCompleteVerification = computed(function () {
      return !isError.value && ![USER_STATUS.KYC_REJECTED, USER_STATUS.PENDING_EMAIL_CONFIRMATION, USER_STATUS.DISABLED].includes(status.value);
    });
    var proLabels = ['Selfie', 'Government issued ID', 'Phone Number', 'Proof of Address', 'Source of Funds and Wealth'];
    var investmentManagerIndividualLabels = ['Selfie', 'Government issued ID', 'Proof of Address'];
    var corporateLabels = ['Business Information', 'Authorized persons information', 'Beneficial ownership and directors information', 'Supporting Corporate Documents'];
    var investmentManagerCorporateLabels = ['Business Information', 'Authorized persons information', 'Beneficial ownership and directors information', 'Supporting Corporate Documents'];
    var isInvestmentManager = computed(function () {
      return selectedLegalRole.value === USER_LEGAL_ROLES.INVESTMENT_MANAGER;
    });
    var individualRequirementLabels = computed(function () {
      return isInvestmentManager.value ? investmentManagerIndividualLabels : proLabels;
    });
    var corporateRequirementLabels = computed(function () {
      return isInvestmentManager.value ? investmentManagerCorporateLabels : corporateLabels;
    });
    var proIndividualRestrictions = ['Qualified investor requirements should be met', 'No US individuals accepted', 'Minimum balance requirement USD 100 000 or its equivalent'];
    var investmentManagerIndividualRestrictions = ['No US individuals accepted'];
    var proCorporateRestrictions = ['No US based entities accepted'];
    var investmentManagerCorporateRestrictions = ['No US based entities accepted'];
    var individualRestrictions = computed(function () {
      return isInvestmentManager.value ? investmentManagerIndividualRestrictions : proIndividualRestrictions;
    });
    var corporateRestrictions = computed(function () {
      return isInvestmentManager.value ? investmentManagerCorporateRestrictions : proCorporateRestrictions;
    });
    var buttonTitle = computed(function () {
      if (user.value.status === USER_STATUS.PENDING_KYC) {
        if (localStorage.getItem("verification_in_progress") === "true") {
          return "Complete verification";
        }
        return "Start verification";
      }
      return "";
    });
    var showForms = computed(function () {
      return !isError.value && user.value.status === USER_STATUS.PENDING_KYC && !user.value.detelioLink;
    });
    var relationshipOptions = [{
      title: 'Prime Brokerage platform User/Client',
      icon: 'user-investor',
      value: USER_LEGAL_ROLES.USER
    }, {
      title: 'Investment Manager at Bequant',
      icon: 'briefcase',
      value: USER_LEGAL_ROLES.INVESTMENT_MANAGER
    }];
    var DEFAULT_INVDIVIDUAL_FORM = {
      firstName: null,
      lastName: null
    };
    var DEFAULT_CORPORATE_FORM = {
      corporateName: null
    };
    var individualForm = reactive(_objectSpread({}, DEFAULT_INVDIVIDUAL_FORM));
    var corporateForm = reactive(_objectSpread({}, DEFAULT_CORPORATE_FORM));
    var submittingIndividual = ref(false);
    var submittingCorporate = ref(false);
    var isError = ref(false);
    var errorRequestId = ref('');
    var selectedLegalRole = ref(null);
    var relationshipConfirmed = ref(false);
    var showRelationshipStep = computed(function () {
      return showForms.value && !relationshipConfirmed.value;
    });
    var showVerificationStep = computed(function () {
      return showForms.value && relationshipConfirmed.value;
    });
    function resetIndividualForm() {
      individualForm.firstName = DEFAULT_INVDIVIDUAL_FORM.firstName;
      individualForm.lastName = DEFAULT_INVDIVIDUAL_FORM.lastName;
    }
    function resetCorporateForm() {
      corporateForm.corporateName = DEFAULT_CORPORATE_FORM.corporateName;
    }
    function reset() {
      isError.value = false;
      errorRequestId.value = '';
      resetIndividualForm();
      resetCorporateForm();
    }
    var validationResultIndividual = computed(function () {
      return verificationIndividualSuite(individualForm);
    });
    var validationResultCorporate = computed(function () {
      return verificationCorporateSuite(corporateForm);
    });
    function submit(_x) {
      return _submit.apply(this, arguments);
    }
    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var isIndividual, validationResult, submitting, params, result, data, url, _error$response, response, headers;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isIndividual = _ref.isIndividual;
              validationResult = isIndividual ? validationResultIndividual : validationResultCorporate;
              submitting = isIndividual ? submittingIndividual : submittingCorporate;
              if (!(!validationResult.value.isValid() || submitting.value)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              params = {
                type: isIndividual ? 'individual' : 'legal_entity',
                payload: isIndividual ? individualForm : corporateForm,
                role: selectedLegalRole.value
              };
              _context.prev = 6;
              submitting.value = true;
              _context.next = 10;
              return store.dispatch("detelio/createVerification", params);
            case 10:
              result = _context.sent;
              data = result.data;
              url = data.url;
              submitting.value = false;
              window.location.href = url;
              isError.value = false;
              // reset();
              // suite.reset();
              _context.next = 25;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);
              _error$response = _context.t0.response, response = _error$response === void 0 ? {} : _error$response;
              headers = response.headers;
              submitting.value = false;
              isError.value = true;
              errorRequestId.value = headers['x-request-id'];
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 18]]);
      }));
      return _submit.apply(this, arguments);
    }
    function proceedToVerification() {
      if (selectedLegalRole.value === null) {
        return;
      }
      relationshipConfirmed.value = true;
    }
    function selectRelationship(legalRole) {
      selectedLegalRole.value = legalRole;
    }
    function goToVerification() {
      localStorage.setItem("verification_in_progress", "true");
      window.location.href = user.value.detelioLink;
    }
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_PBButton = _resolveComponent("PBButton");
      var _component_PBBadge = _resolveComponent("PBBadge");
      var _component_PBInput = _resolveComponent("PBInput");
      var _component_PBStatus = _resolveComponent("PBStatus");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Header, {
        empty: ""
      }), _createElementVNode("div", _hoisted_2, [showRelationshipStep.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        "class": "mb-2xl text-center"
      }, [_createElementVNode("h1", {
        "class": "text-2xl font-bold"
      }, " Please select what is your relationship with Bequant. "), _createElementVNode("p", {
        "class": "mx-auto my-xl max-w-[350px] text-zinc-500"
      }, " Please note that the verification requirements will differ based on your selection. ")], -1)), _createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(relationshipOptions, function (option) {
        return _createElementVNode("button", {
          key: option.value,
          type: "button",
          "class": "VerificationRelationshipButton w-full text-left",
          onClick: function onClick($event) {
            return selectRelationship(option.value);
          }
        }, [_createElementVNode("div", {
          "class": _normalizeClass(["Section VerificationRelationshipCard flex flex-col items-center h-full p-12 text-center border border-solid transition-all duration-200", _unref(selectedLegalRole) === option.value ? 'border-primary' : 'border-transparent'])
        }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_PBIcon, {
          name: option.icon,
          w: 44,
          h: 44,
          "class": "text-primary"
        }, null, 8, ["name"])]), _createElementVNode("div", _hoisted_8, _toDisplayString(option.title), 1)], 2)], 8, _hoisted_6);
      }), 64))]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_PBButton, {
        large: "",
        "class": "min-w-[296px]",
        disabled: _unref(selectedLegalRole) === null,
        onClick: _withModifiers(proceedToVerification, ["prevent"])
      }, {
        "default": _withCtx(function () {
          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode(" Proceed ", -1)]));
        }),
        _: 1
      }, 8, ["disabled"])])])])) : showVerificationStep.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[16] || (_cache[16] = _createElementVNode("h2", {
        "class": "Header__bottom w-full py-[22px] text-2xl font-bold"
      }, " Verification Levels ", -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[7] || (_cache[7] = _createTextVNode(" Individual ", -1)), _createVNode(_component_PBBadge, {
        color: {
          warning: true
        },
        "class": "ml-6 text-sm"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(isInvestmentManager.value ? 'Investment managers only' : 'Experienced investors only'), 1)];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, _toDisplayString(isInvestmentManager.value ? 'Verify your account to become an Investment Manager at Bequant.' : 'Prime brokerage for individual professionals. Verify your account and start trading in minutes.'), 1), _cache[9] || (_cache[9] = _createElementVNode("div", {
        "class": "mb-4 text-lg font-semibold"
      }, " Requirements ", -1)), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(individualRequirementLabels.value, function (label, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          "class": "flex items-center px-2 py-1 bg-secondary border border-[#666666] border-solid rounded text-xs font-bold"
        }, [_createVNode(_component_PBIcon, {
          name: "shield",
          w: 12,
          h: 14,
          "class": "mr-2"
        }), _createTextVNode(" " + _toDisplayString(label), 1)]);
      }), 128))]), _cache[10] || (_cache[10] = _createElementVNode("div", {
        "class": "mb-4 text-lg font-semibold"
      }, " Restrictions ", -1)), _createElementVNode("ul", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(individualRestrictions.value, function (restriction, index) {
        return _openBlock(), _createElementBlock("li", {
          key: restriction,
          "class": _normalizeClass(index < individualRestrictions.value.length - 1 ? 'mb-4 pl-3' : 'pl-3')
        }, _toDisplayString(restriction), 3);
      }), 128))]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_PBInput, {
        modelValue: _unref(individualForm).firstName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(individualForm).firstName = $event;
        }),
        error: validationResultIndividual.value.getErrors('firstName')[0],
        label: "First Name",
        placeholder: "John"
      }, null, 8, ["modelValue", "error"]), _createVNode(_component_PBInput, {
        modelValue: _unref(individualForm).lastName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _unref(individualForm).lastName = $event;
        }),
        error: validationResultIndividual.value.getErrors('lastName')[0],
        label: "Last Name",
        placeholder: "Doe",
        "class": "mt-8"
      }, null, 8, ["modelValue", "error"])]), _createElementVNode("div", _hoisted_20, [_createVNode(PBKYCFlow)]), _createVNode(_component_PBButton, {
        full: "",
        large: "",
        disabled: !validationResultIndividual.value.isValid(),
        loading: _unref(submittingIndividual),
        onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
          return submit({
            isIndividual: true
          });
        }, ["prevent"]))
      }, {
        "default": _withCtx(function () {
          return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode(" Proceed ", -1)]));
        }),
        _: 1
      }, 8, ["disabled", "loading"])])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[12] || (_cache[12] = _createTextVNode(" Corporate ", -1)), isInvestmentManager.value ? (_openBlock(), _createBlock(_component_PBBadge, {
        key: 0,
        color: {
          warning: true
        },
        "class": "ml-6 text-sm"
      }, {
        "default": _withCtx(function () {
          return _toConsumableArray(_cache[11] || (_cache[11] = [_createTextVNode(" Investment managers only ", -1)]));
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("p", _hoisted_25, _toDisplayString(isInvestmentManager.value ? 'Verify your account to become an Investment Manager at Bequant.' : 'Access the full range of Prime brokerage services for institutional clients'), 1), _cache[14] || (_cache[14] = _createElementVNode("div", {
        "class": "mb-4 text-lg font-semibold"
      }, " Requirements ", -1)), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corporateRequirementLabels.value, function (label, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          "class": "flex items-center px-2 py-1 bg-secondary border border-[#666666] border-solid rounded text-xs font-bold"
        }, [_createVNode(_component_PBIcon, {
          name: "shield",
          w: 12,
          h: 14,
          "class": "mr-2"
        }), _createTextVNode(" " + _toDisplayString(label), 1)]);
      }), 128))]), _cache[15] || (_cache[15] = _createElementVNode("div", {
        "class": "mb-4 text-lg font-semibold"
      }, " Restrictions ", -1)), _createElementVNode("ul", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corporateRestrictions.value, function (restriction) {
        return _openBlock(), _createElementBlock("li", {
          key: restriction,
          "class": "pl-3"
        }, _toDisplayString(restriction), 1);
      }), 128))]), _createElementVNode("div", {
        "class": _normalizeClass(["mt-8 mb-8", isInvestmentManager.value ? 'xl:mt-[66px]' : 'xl:mt-[98px]'])
      }, [_createVNode(_component_PBInput, {
        modelValue: _unref(corporateForm).corporateName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _unref(corporateForm).corporateName = $event;
        }),
        error: validationResultCorporate.value.getErrors('corporateName')[0],
        label: "Full Corporate Name",
        placeholder: "Enter corporate name"
      }, null, 8, ["modelValue", "error"])], 2), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(PBKYCFlow)]), _createVNode(_component_PBButton, {
        full: "",
        large: "",
        disabled: !validationResultCorporate.value.isValid(),
        loading: _unref(submittingCorporate),
        onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
          return submit({
            isIndividual: false
          });
        }, ["prevent"]))
      }, {
        "default": _withCtx(function () {
          return _toConsumableArray(_cache[13] || (_cache[13] = [_createTextVNode(" Proceed ", -1)]));
        }),
        _: 1
      }, 8, ["disabled", "loading"])])])])])])])) : shouldCompleteVerification.value ? (_openBlock(), _createBlock(_component_PBStatus, {
        key: 2,
        warning: "",
        "primary-text": buttonTitle.value,
        message: "Dear client",
        "class": "mt-8",
        onPrimary: goToVerification
      }, {
        "default": _withCtx(function () {
          return [isPendingKyc.value && verificationInProgress.value ? (_openBlock(), _createElementBlock("span", _hoisted_30, " Your account verification has not been completed. Click on the link below to complete the account verification process to enable your account. ")) : isPendingKyc.value ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Your account is not active at present. Click on the link below to start the account verification process to enable your account. ")) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["primary-text"])) : _unref(isError) ? (_openBlock(), _createBlock(_component_PBStatus, {
        key: 3,
        message: "User creation failed",
        "primary-text": "Try Again",
        error: "",
        "class": "mt-8",
        onPrimary: reset
      }, {
        "default": _withCtx(function () {
          return [_cache[17] || (_cache[17] = _createElementVNode("p", null, " Please contact support@bequant.io. ", -1)), _createElementVNode("p", _hoisted_32, " Request ID: " + _toDisplayString(_unref(errorRequestId)), 1)];
        }),
        _: 1
      })) : (_openBlock(), _createBlock(_component_PBStatus, {
        key: 4,
        "class": "mt-8",
        empty: "",
        warning: ""
      }, {
        "default": _withCtx(function () {
          return [isDisabled.value ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toConsumableArray(_cache[18] || (_cache[18] = [_createTextVNode(" Unfortunately, your account has been disabled. To find out why your account was disabled or if you think this is a mistake, please contact ", -1), _createElementVNode("a", {
            href: "mailto:support@bequant.io"
          }, "support@bequant.io", -1), _createTextVNode(". ", -1)])))) : isPendingEmail.value ? (_openBlock(), _createElementBlock("span", _hoisted_34, " Before you can login, please confirm your email address. ")) : isKycRejected.value ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toConsumableArray(_cache[19] || (_cache[19] = [_createTextVNode(" We appreciate your interest in BEQUANT Prime. Unfortunately, we have been unable to verify your account with our verification process. To verify your account, please contact ", -1), _createElementVNode("a", {
            href: "mailto:support@bequant.io"
          }, "support@bequant.io", -1), _createTextVNode(". ", -1)])))) : _createCommentVNode("", true)];
        }),
        _: 1
      }))]), _createVNode(Footer, {
        empty: ""
      })]);
    };
  }
};